import { PASTEL_COLORS } from '../constants';

// Helper function to generate consistent user color
export const getUserColor = (userId) => {
  if (!userId) return PASTEL_COLORS[0];
  
  let hash = 0;
  for (let i = 0; i < userId.length; i++) {
    const char = userId.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash;
  }
  
  return PASTEL_COLORS[Math.abs(hash) % PASTEL_COLORS.length];
};

// Helper function to get darker text color for contrast
export const getDarkerTextColor = (hexColor) => {
  // Remove the # if present
  const hex = hexColor.replace('#', '');
  
  // Parse RGB values
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);
  
  // Generate darker versions (reduce each component by about 40-60%)
  const darkerR = Math.max(0, Math.floor(r * 0.4));
  const darkerG = Math.max(0, Math.floor(g * 0.4));
  const darkerB = Math.max(0, Math.floor(b * 0.4));
  
  // Convert back to hex
  const toHex = (n) => n.toString(16).padStart(2, '0');
  return `#${toHex(darkerR)}${toHex(darkerG)}${toHex(darkerB)}`;
};

// Helper function to get user information for project chats
export const getUserInfo = (userId, projectData, currentUser) => {
  if (!projectData?.members || !userId) return null;
  
  // Check if it's the current user
  if (userId === currentUser?.id) {
    return {
      id: currentUser.id,
      name: 'Me',
      profileImage: currentUser.profileImage,
      isCurrentUser: true
    };
  }
  
  // Find the user in project members
  const member = projectData.members.find(member => member.id === userId);
  if (member) {
    return {
      id: member.id,
      name: member.name,
      profileImage: member.profileImage,
      isCurrentUser: false
    };
  }
  
  return null;
};

// Helper function to get user initials
export const getUserInitials = (user, currentUser) => {
  if (user?.isCurrentUser) {
    // For current user, use their actual initials
    if (currentUser?.firstName && currentUser?.lastName) {
      return `${currentUser.firstName.charAt(0)}${currentUser.lastName.charAt(0)}`.toUpperCase();
    }
    return 'ME';
  }
  
  if (user?.name) {
    const nameParts = user.name.trim().split(' ');
    if (nameParts.length >= 2) {
      return `${nameParts[0].charAt(0)}${nameParts[nameParts.length - 1].charAt(0)}`.toUpperCase();
    } else {
      return nameParts[0].charAt(0).toUpperCase();
    }
  }
  
  return 'U';
}; 